import TermsInputFcl from "./terms-input-fcl.component";

export default TermsInputFcl;
